import { CapacitorConfig } from '@capacitor/cli';
import { KeyboardResize } from '@capacitor/keyboard';

export type AppConfig = CapacitorConfig & {
  plugins: {
    SocialLogin: {
      google: {
        webClientId: string;
        iOSClientId: string;
        mode: 'online' | 'offline';
      }
      apple: {
        clientId: string;
      }
    }
  }
};

const config: AppConfig = {
  appId: 'com.workingdevshero.heybible',
  appName: 'Hey Bible',
  webDir: 'www/browser',
  ios: {
    scheme: 'Hey Bible',
  },
  server: {
    androidScheme: 'https',
  },
  plugins: {
    // Resizing the WKWebView itself (rather than only <body>) keeps ion-content
    // as the chat's sole scroller and lifts its pinned ion-footer above the
    // keyboard. resizeOnFullScreen is the Android counterpart: with the status
    // bar overlaying the WebView the system otherwise skips the resize.
    Keyboard: {
      resize: KeyboardResize.Native,
      resizeOnFullScreen: true,
    },
    SocialLogin: {
      google: {
        webClientId:
          '822749582074-bc5ajg5aiiq6sa53kqvjd02uvo7arpqp.apps.googleusercontent.com',
        iOSClientId:
          '822749582074-d2a641ekn915orhb9dvt4fvno3mbii0a.apps.googleusercontent.com',
        mode: 'online',
      },
      apple: {
        clientId: 'com.workingdevshero.heybible',
      },
    },
  },
};

export default config;
